
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { ActivatedRoute, Params } from '@angular/router';
import { resultScreen } from 'modules/shared-postlogin/interfaces/result-screen.model';
import { ProductViewHelperService } from 'modules/shared-postlogin/services/product-view-helper.service';

@Component({
    selector: 'result-screen',
    templateUrl: './result-screen.template.html',
    styleUrls: ['./result-screen.style.scss'],
    standalone: false
})
export class ResultScreen implements OnInit {
    
    selectedItemSubscription: Subscription;
    paramsSubscription: Subscription;
    selectedItem: any = {};
    productCode: string;
    /* Const object to determine the text/styles/assets to be shown on the result screen */
    resultScreen: any = resultScreen;
    /* Object containing result data to be shown on the result screen */
    resultData: any = {};
    segment: string = '';
    /* Threshold acheived (above/below) by the user */
    threshold: string;
    /* Object containing control type and action to perform on click of review button (for case when C1 result screen shown) */
    reviewAction: any = {
        controlType: '',
        action: '',
    };
    public imageBasePath: string = IMAGES_BASEPATH;

    /* Boolean to show/hide result screen */
    @Input() showResultScreen: boolean;
    /* Boolean to show/hide next activity button */
    @Input() showNextActivityBtn: boolean;
    /* launch next activity */
    @Output() nextActivity = new EventEmitter<string>();
    /* launch activity again */
    @Output() relaunchActivity = new EventEmitter<string>();
    @Output() actionControl = new EventEmitter<any>();
    /* to trigger show results event */
    @Input() showResultScreenEvent: Subject<any>;

    constructor(
        private route: ActivatedRoute,
        private productViewHelperService: ProductViewHelperService,
    ) { }

    ngOnInit() {
        var productTocData = this.route.snapshot.data.resolveData.productData;
        this.paramsSubscription = this.route.params.subscribe((params: Params) => {
            this.productCode = params.productcode;
        });
        //Get segment - to display corresponding result screen accordingly
        const classProduct = productTocData.bundleDetails.products.find((product) => product['dls-product'].code === this.productCode);
        this.segment = classProduct.segment ? classProduct.segment.segment : 'primary';
        this.selectedItemSubscription = this.productViewHelperService.selectedItemId.subscribe(
            (selectedItemObject: any) => {
                this.selectedItem = selectedItemObject?.selectedItem ?? {};
            });
        this.showResultScreenEvent.subscribe((containerEventData) => {
            let LOinitParams = this.productViewHelperService.getLOInitParams();
            /* Temp hardcoding - content will provide the action in future */
            this.reviewAction.controlType = LOinitParams.container.type === 'generic-content' ? 'generic_controls' : 'avallain_controls';
            this.reviewAction.action = this.reviewAction.controlType === 'generic_controls' ? 'reviewAnswers' : 'goToExerciseScreen';
            this.resultData = containerEventData;
            let toc = productTocData.toc.tocObject;
            let passScore = toc[this.selectedItem.unitId].items[this.selectedItem.lessonId].items[this.selectedItem.activityId]['pass-score'];
            this.threshold = containerEventData.score.scaled >= passScore ? 'top_threshold' : 'bottom_threshold';
        });
    }
    ngOnDestroy() {
        this.showResultScreenEvent.unsubscribe();
    }

    launchNextActivity() {
        this.nextActivity.emit();
    }

    launchActivityAgain() {
        this.relaunchActivity.emit();
    }

    reviewAnswers(containerType, type) {
        this.actionControl.emit({ containerType: containerType, type: type });
    }

}
